module.exports = __webpack_public_path__ + "img/2.58832af0.png";